module.exports = __webpack_public_path__ + "img/list_Character_sq_12.40552731.jpeg";